import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';

class CampusTransfer extends ChemComponent {
	constructor(props) {
		super(props);
		
		var search = {
			ROOM_ID: null,
			ROOM_NAME: '',
			BOTTLE_COUNT: null,
			PRINT_SECTION: null
		};
		
		var transferListInit = this.copyTable(transferList);
		transferListInit.ajax.data = {
			search: search
		};

		this.state = {
			search: search,
			transferSearch: this.copyColumns(transferSearch),
			transferList: transferListInit,
			showSearch: true,
			searchCount: 0,
			renderKey: 0
		};
	}

	onChangeSearch(accessor, value) {
		var newTransferSearch = this.copyColumns(this.state.transferSearch);
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		// if we have chosen a room
		if (Array.isArray(accessor) && accessor.includes('ROOM_ID')) {
			// find the print section count
			var psct;
			for (var i = 0; i < accessor.length; i++) {
				if (accessor[i] === 'PRINT_SECTION') {
					psct = value[i];
					break;
				}
			}
			
			// if print section count was found
			if (this.isNumeric(psct)) {
				// create new options for retrieve section
				var rsOptions = [{ value: null, label: 'All' }];
				for (var s = 1; s <= psct; s++) rsOptions.push({ value: s, label: '' + s });
				
				// replace current options with new options
				var rsIdx = this.findColumnByAccessor(newTransferSearch, 'RETRIEVE_SECTION');
				newTransferSearch[rsIdx].options = rsOptions;
			}	
		}

		this.mergeStateWithArrays({
			search: search,
			transferSearch: newTransferSearch,
			renderKey: this.state.renderKey + 1
		});
	}

	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event) {
		var newTransferList = this.copyTable(transferList);
		newTransferList.ajax.data = {
			search: this.copyObject(this.state.search)
		};
		newTransferList.hold = false;
		
		this.mergeState({
			transferList: newTransferList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onSearchResult(data) {		
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'CampusTransfer',
			columns: exportColumns,
			search: this.state.search
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Campus Transfer</div>
						{this.state.showSearch && <ChemEdit parent={this} user={this.props.user} columns={this.state.transferSearch} data={this.state.search}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Reuse/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Reuse/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						{this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Reuse_Campus_Transfer' table={this.state.transferList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const transferSearch = [
	{ Header: 'Room', accessor: 'ROOM_ID', labelAccessor: ['ROOM_NAME','BOTTLE_COUNT','PRINT_SECTION'], type: 'multicolumn', row: 0, col: 0,
		options: { value: 'ROOM_ID', label: ['ROOM_NAME','BOTTLE_COUNT','PRINT_SECTION'], entity: 'REUSE.CT_ROOM_SELECT_VW' }},
	{ Header: 'Bottle Count', accessor: 'BOTTLE_COUNT', row: 0, col: 1, editable: false },
	{ Header: 'Print Sections', accessor: 'PRINT_SECTION', row: 0, col: 2, editable: false },
	{ Header: 'Retrieve Section', accessor: 'RETRIEVE_SECTION', type: 'select', row: 0, col: 3,
		options: [{ value: null, label: 'All' }]},
];

const transferList = {
	ajax: {
		url: '/Reuse/CampusTransfer',
		data: null,
		accessor: 'Data'
	},
	pageSize: 20,
	hold: true,
	columns: [
		{ Header: 'AROWNUM', accessor: 'AROWNUM', width: 125 },
		{ Header: 'CHEMICAL_NAME', accessor: 'CHEMICAL_NAME', width: 500 },
		{ Header: 'CHEMICAL_CONCENTRATION', accessor: 'CHEMICAL_CONCENTRATION', width: 220 },
		{ Header: '%', accessor: 'PCT', width: 30 },
		{ Header: 'CAS', accessor: 'CAS', width: 100 },
		{ Header: 'CONTAINER_SIZE', accessor: 'CONTAINER_SIZE', width: 135 },
		{ Header: 'UNITS', accessor: 'UNITS', width: 60 },
		{ Header: 'CONTAINER_NUMBER', accessor: 'CONTAINER_NUMBER', width: 170 },
		{ Header: 'CHEMICAL_PHYSICAL_STATE', accessor: 'CHEMICAL_PHYSICAL_STATE', width: 210 },
		{ Header: 'CONTAINER_TYPE', accessor: 'CONTAINER_TYPE', width: 135 },
		{ Header: 'HAZMAT_TYPE', accessor: 'HAZMAT_TYPE', width: 120 },
		{ Header: 'STORAGE_PRESSURE', accessor: 'STORAGE_PRESSURE', width: 160 },
		{ Header: 'STORAGE_TEMPERATURE', accessor: 'STORAGE_TEMPERATURE', width: 200 },
		{ Header: 'LOCATION', accessor: 'LOCATION', width: 100 }
	]
};

const exportColumns = [
	{ Header: 'AROWNUM', accessor: 'AROWNUM', width: 25 },
	{ Header: 'CHEMICAL_NAME', accessor: 'CHEMICAL_NAME', width: 100 },
	{ Header: 'CHEMICAL_CONCENTRATION', accessor: 'CHEMICAL_CONCENTRATION', width: 44 },
	{ Header: '%', accessor: 'PCT', width: 6 },
	{ Header: 'CAS', accessor: 'CAS', width: 20 },
	{ Header: 'CONTAINER_SIZE', accessor: 'CONTAINER_SIZE', width: 27 },
	{ Header: 'UNITS', accessor: 'UNITS', width: 12 },
	{ Header: 'CONTAINER_NUMBER', accessor: 'CONTAINER_NUMBER', width: 34 },
	{ Header: 'CHEMICAL_PHYSICAL_STATE', accessor: 'CHEMICAL_PHYSICAL_STATE', width: 42 },
	{ Header: 'CONTAINER_TYPE', accessor: 'CONTAINER_TYPE', width: 27 },
	{ Header: 'HAZMAT_TYPE', accessor: 'HAZMAT_TYPE', width: 24 },
	{ Header: 'STORAGE_PRESSURE', accessor: 'STORAGE_PRESSURE', width: 32 },
	{ Header: 'STORAGE_TEMPERATURE', accessor: 'STORAGE_TEMPERATURE', width: 40 },
	{ Header: 'LOCATION', accessor: 'LOCATION', width: 20 }
];

export default withRouter(CampusTransfer);
